import { createContext, useContext } from 'react';

export type AuthStatus = {
  /**
   * True while MSAL is verifying the user's session — i.e. while
   * `handleRedirectPromise`, cached-account hydration, and `ssoSilent`
   * are in flight on initial mount.
   *
   * Surfaces this phase to the landing UI so the "Sign in" buttons can
   * render disabled with a spinner ("Verifying access…") instead of
   * either (a) showing a clickable button that fires `loginRedirect`
   * before silent SSO has had a chance, or (b) gating the entire app
   * render behind a full-page blank screen.
   */
  isVerifyingAuth: boolean;
};

/**
 * Default value matches the mock / E2E case where there is no async
 * auth-init phase. The real `AuthProvider` overrides this while it works.
 */
export const AuthStatusContext = createContext<AuthStatus>({ isVerifyingAuth: false });

export const useAuthStatus = (): AuthStatus => useContext(AuthStatusContext);
